export default __webpack_public_path__ + "static/media/arrow-button-circle-right.50836e82.svg";